import React, { useMemo, useState } from 'react';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Icons
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import FavouriteServices from './FavouriteServices';

const servicesGroupOne = [
  {
    title: 'Obedience Training',
    description:
      'Mistress Diva will mould you into the perfectly obedient servant you were meant to be. Strict, commanding, and deeply rewarding.',
  },
  {
    title: 'Financial Domination',
    description:
      'Experience true devotion through tribute. Mistress Diva expertly commands control over your wallet and your will.',
  },
  {
    title: 'Humiliation & Degradation',
    description:
      'Unleash your deepest shame fantasies. Verbal, physical, and psychological play tailored to your limits.',
  },
  {
    title: 'Chastity Control',
    description:
      'Your pleasure belongs to Mistress now. Long-term or session-based control available with strict rules.',
  },
  {
    title: 'Foot Worship',
    description:
      'Kneel and adore. Mistress Diva’s perfect feet are available to those who’ve earned the privilege.',
  },
];

const servicesGroupTwo = [
  {
    title: 'Sissy Training',
    description:
      'Be transformed and guided into your true submissive sissy self with precision and style by Mistress Diva.',
  },
  {
    title: 'Roleplay Scenarios',
    description:
      'From boss/employee to dark fantasy scenes, Mistress Diva brings your imagination to life.',
  },
  {
    title: 'Pain & Impact Play',
    description:
      'From light spanking to hardcore sessions, Mistress controls the rhythm and intensity.',
  },
  {
    title: 'Public Exposure Tasks',
    description:
      'Are you brave enough? Mistress may assign daring tasks to test your loyalty and thrill your submission.',
  },
  {
    title: 'Domestic Servitude',
    description:
      'Serve. Clean. Obey. Experience the structure and fulfilment of real-time or online domestic service.',
  },
];

function ServiceSection1({ services }) {
  const [hovered, setHovered] = useState(null);

  return (
    <div className='grid lg:grid-cols-2 h-full'>
      {/* Options */}
      <section className='grid justify-right items-center'>
        <div className='grid h-fit my-auto w-fit bg-colour2/70 shadow-cardShadowBold shadow-colour4/60 text-white'>
          {services.map((service, idx) => (
            <div
              key={idx}
              onMouseEnter={() => setHovered(service)}
              onMouseLeave={() => setHovered(null)}
              className='cursor-pointer items-center flex py-4 px-4 lg:px-8 lg:text-xl hover:text-colour4 transition duration-300 full_shadow_red_invert h-fit'
            >
              <div className='grid grid-cols-rev w-full gap-x-2 items-center h-fit'>
                <div className='font-kugile'>{service.title}</div>
                <div>
                  <span className=''>
                    <MdKeyboardDoubleArrowRight />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Answer */}
      <section className='p-6 flex items-center justify-center text-center text-colour1'>
        {hovered && (
          <div className='grid max-w-xl py-6 px-8 bg-colour2/70 h-fit shadow-cardShadowBold shadow-colour4/60'>
            <h4 className='text-2xl lg:text-5xl font-kugile'>
              {hovered.title}
            </h4>
            <p className='text-lg'>{hovered.description}</p>
          </div>
        )}
      </section>
    </div>
  );
}

function ServiceSection2({ services }) {
  const [hovered, setHovered] = useState(null);

  return (
    <div className='grid lg:grid-cols-2 h-full pointer-events-auto'>
      {/* Answer */}
      <section className='p-6 flex items-center justify-center text-center text-colour1'>
        {hovered && (
          <div className='grid max-w-xl py-6 px-8 bg-colour2/70 h-fit shadow-cardShadowBold shadow-colour4/60'>
            <h4 className='text-2xl lg:text-5xl font-kugile'>
              {hovered.title}
            </h4>
            <p className='text-lg'>{hovered.description}</p>
          </div>
        )}
      </section>

      {/* Options */}
      <section className='grid relative'>
        <div className='grid absolute right-[5%] top-[8%] h-fit z-50 w-fit bg-colour2/70 shadow-cardShadowBold shadow-colour4/60 text-white'>
          {services.map((service, idx) => (
            <div
              key={idx}
              onMouseEnter={() => setHovered(service)}
              onMouseLeave={() => setHovered(null)}
              className='cursor-pointer items-center flex h-fit py-2 px-2 lg:px-8 lg:text-xl hover:text-colour4 transition duration-300 full_shadow_red_invert'
            >
              <div className='grid grid-cols-reg w-full h-fit gap-x-1 items-center'>
                <div>
                  <span>
                    <MdKeyboardDoubleArrowRight className='rotate-180' />
                  </span>
                </div>
                <div className='font-kugile'>{service.title}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function ServicesPageMainContainer() {
    const isIOS = useMemo(() => {
    if (typeof navigator === 'undefined') return false
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  }, [])

  // pick the right attachment class
  const attachmentClass = isIOS ? 'bg-scroll' : 'bg-fixed'

  return (
    <main
      role='main'
      className='grid w-full h-full overflow-hidden pt-[100vh] z-10 pointer-events-none'
    >
      {/* First Service Section */}
      <section className={`paralax min-h-screen bg-paraOne bg-cover bg-no-repeat ${attachmentClass} bg-center w-full`}>
        <ServiceSection2 services={servicesGroupOne} />
      </section>

      {/* Second Service Section */}
      <section className='grid relative h-screen bg-paraAlt bg-cover bg-no-repeat bg-center w-full'>
        <div className='grid absolute top-8 left-8 lg:max-w-[50%] text-xl gap-y-2'>
          <p>
            "The mask took me to a new level of slightly out of my comfort zone,
            wondering what was going to happen next."...
          </p>
          <p>your slave - Dec 2024</p>
        </div>
      </section>

      {/* Services */}
      <FavouriteServices />

      {/* Footer */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default ServicesPageMainContainer;
